import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Datos del método" className="w-full bg-pitch" data-id="element-206" data-mp="1j8ma64pvky1q">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-4 px-5 py-6" data-id="element-207" data-mp="1j6rm4hjb4ptf">
        {stats.map(stat => <div key={stat.label} className="min-w-[120px] text-center" data-id="element-208" data-mp="1syxe3r9k778m">
            <p className="font-display text-4xl font-black text-brand-gold md:text-5xl" data-id="element-209" data-mp="1x0ama804jmip">
              {stat.value}
            </p>
            <p className="mt-1 text-sm font-semibold text-body" data-id="element-210" data-mp="21yc4yrtn1jtn">{stat.label}</p>
          </div>)}
      </div>
    </section>;
}